export default "__VITE_ASSET__9795b5ad__"